import { Tag } from '@getro/rombo';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import SearchLocation from '../../components/molecules/SearchLocation';
import MultiSelect from './components/multiSelect';

export const environmentOptions = [
  {
    id: 1,
    label: 'Onsite',
    value: 'onsite',
    description: 'I’m open to working at a physical office.',
  },
  {
    id: 2,
    label: 'Hybrid',
    value: 'hybrid',
    description: 'I’m open to a combination of office and remote work.',
  },
  {
    id: 3,
    label: 'Full remote',
    value: 'remote',
    description: 'I’m open to working remotely from any location.',
  },
];

export const Location = ({ onChange, data, variant }) => {
  const [locations, setLocations] = useState(data.locations ?? []);

  return (
    <Box pb="160px">
      <Box mb="40px">
        <Text mb="8px" color="text.dark" fontSize="16px" fontWeight="500" lineHeight="24px">
          Environment type
        </Text>
        <MultiSelect
          initialData={data.environment}
          onChange={(environment) => onChange('location', { ...data, environment })}
          options={environmentOptions}
          type="checkbox"
          variant={variant}
        />
      </Box>
      <Box sx={{ label: { display: 'none' } }}>
        <Text mb="8px" color="text.dark" fontSize="16px" fontWeight="500" lineHeight="24px">
          Preferred locations
        </Text>
        <Text color="text.main" fontSize="14px" mb="8px" lineHeight="20px">
          Select where you&apos;d like to work from, include where you&apos;d expect to work from remotely.
        </Text>
        <SearchLocation
          name="location"
          label="location"
          placeholder="Type to search"
          onChange={({ target }) => {
            const updatedLocations = [...locations.filter((item) => target.value.value !== item.value), target.value];
            setLocations(updatedLocations);
            onChange('location', { ...data, locations: updatedLocations });
          }}
        />
        {locations.length > 0 && (
          <Flex flexDirection="row" flexWrap="wrap">
            {locations.map((location) => (
              <Tag
                key={`job_location_${location.value}`}
                mt={2}
                onRemove={() => {
                  const updatedLocations = locations.filter((item) => item.value !== location.value);
                  setLocations(locations.filter((item) => item.value !== location.value));
                  onChange('location', { ...data, locations: updatedLocations });
                }}
              >
                {location.label}
              </Tag>
            ))}
          </Flex>
        )}
      </Box>
    </Box>
  );
};

Location.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

Location.defaultProps = {
  variant: 'onboarding',
};

export default Location;
